import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings } from 'lucide-react';

const OpsSettings = () => {
  return (
    <Card>
      <CardHeader><CardTitle className="flex items-center gap-2"><Settings className="h-5 w-5 text-[#247C75]" />Settings</CardTitle></CardHeader>
      <CardContent>
        <div className="text-center py-12 text-slate-500">
          <Settings className="h-16 w-16 mx-auto mb-4 text-slate-300" />
          <p className="text-lg font-medium mb-2">Settings Coming Soon</p>
          <p className="text-sm">Configure ops manager preferences</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default OpsSettings;